// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"881f4068","95":"2e23bdab","104":"e6cfd3e8","460":"f1baedf4"}[chunkId] + ".chunk.js";
};